import type { IconDefinition } from '../index.tsx';

export const iconMarket: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconMarket',
  icon: [
    16,
    16,
    [],
    '',
    'M4 12H7V9H4V12ZM9 9V15H1.96875V8H1C0.447715 8 0 7.55228 0 7V6.27698C0 6.09574 0.0492581 5.9179 0.142507 5.76249L3 1H13L15.8575 5.76249C15.9507 5.9179 16 6.09574 16 6.27698V7C16 7.55228 15.5523 8 15 8H13.9688V15H12V9H9Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
